import React from "react";
import MarketoFormComponent from '../marketo/marketoFormComponent';
import '../../sass/components/flexibleModules/_components.marketoFormFlexiComponent.scss';
import '../../sass/components/_components.signup.scss';

const MarketoFormFlexiComponent = ({ data }) => {
    return (
        <div className={`cp-marketoFormFlexiComponent ${data.overrideClass}`} style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-marketoFormFlexiComponent__inner" style={{ maxWidth: `${data.maxWidth ? (data.maxWidth/16+"rem") : ""}`, margin: "0 auto" }}>
                {data.marketoFormComponentHeader &&
                    <h2 dangerouslySetInnerHTML={{ __html: data.marketoFormComponentHeader }} />
                }
                {data.marketoFormComponentTeaser &&
                    <p dangerouslySetInnerHTML={{ __html: data.marketoFormComponentTeaser }} />
                }
                {data.marketoFormComponentFormId &&
                    <MarketoFormComponent formId={data.marketoFormComponentFormId} formSubmitMessage={data.marketoFormComponentThankYouMessage} />
                }
                {data.marketoFormComponentZoominfoScript &&
                    <div dangerouslySetInnerHTML={{ __html: data.marketoFormComponentZoominfoScript }} />
                }
            </div>
        </div>
    );
}

export default MarketoFormFlexiComponent;